import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  formLabel: {
    textAlign: 'left',
    marginBottom: '0.75rem !important'
  },
}));
